"use client";

export type LoginEntry = "home";

/** Compatibility for callers that still label the single sign-in entry. */
export function setLoginEntry(_entry: LoginEntry): boolean {
  return true;
}

export function getLoginEntry(): LoginEntry | null {
  return null;
}
